import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// import { getRouterByUser } from './router/index';

import OperatorCachePlugin from '@/assets/cache/OperatorCache';
import './permission';

import { createPinia } from 'pinia';
const pinia = createPinia();

import {
  Button,
  Field,
  CellGroup,
  Dialog,
  TreeSelect,
  Grid,
  GridItem,
  NavBar,
  Collapse,
  CollapseItem,
  Picker,
  Popup,
  Cell,
  Icon,
  Pagination,
  Loading,
  Uploader,
  Form,
  Toast,
  RadioGroup,
  Radio,
  Tag,
} from 'vant';
import 'vant/lib/index.css';

const app = createApp(App);

app.use(Field);
app.use(CellGroup);
app.use(Button);
app.use(Dialog);
app.use(TreeSelect);
app.use(Grid);
app.use(GridItem);
app.use(NavBar);
app.use(Collapse);
app.use(CollapseItem);
app.use(Picker);
app.use(Popup);
app.use(Cell);
app.use(Icon);
app.use(Pagination);
app.use(Loading);
app.use(Uploader);
app.use(Form);
app.use(Toast);
app.use(RadioGroup);
app.use(Radio);
app.use(Tag);

app.use(OperatorCachePlugin);
app.use(pinia);
app.use(store);
// getRouterByUser();
app.use(router);

app.mount('#app');

// createApp(App)
//   .use(Field)
//   .use(CellGroup)
//   .use(Button)
//   .use(store)
//   .use(router)
//   .mount('#app');
